<div class="table-responsive">
    <table class="table basictable">
        <thead>
            <tr>
                <th>Years</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Rent / NOI</th>
                <th>Increase Percentage</th>
                <th *ngIf="IsEditAllowed">Actions</th>
            </tr>
        </thead>
        <tbody *ngIf="PropertyHistoryRentTerms?.length != 0">
            <ng-container *ngFor="let item of PropertyHistoryRentTerms;let i = index">
                <tr *ngIf="!item.IsOptional"  [ngClass]="{'blue-heighligt': showSaleDate(item)}">
                    <td>
                        <p *ngIf="!item.IsEditModeOn">{{item.Years}}</p>
                        <input *ngIf="item.IsEditModeOn" type="text" class="form-control" [(ngModel)]="currentData.Years" [attr.disabled]="!item.IsEditModeOn ? '' : null" />
                    </td>
                    <td>
                        <p *ngIf="!item.IsEditModeOn">{{item.LeaseStartDate  | date: 'MM/dd/yyyy'}}</p>
                        <input placement="top" *ngIf="item.IsEditModeOn" [attr.disabled]="!item.IsEditModeOn ? '' : null" (ngModelChange)="dateOverlapValidation($event,1, i)" type="text" maxlength="10" [(ngModel)]="currentData.LeaseStartDate" required="required" class="form-control" bsDatepicker>
                    </td>
                    <td>
                        <p *ngIf="!item.IsEditModeOn">{{item.LeaseEndDate | date: 'MM/dd/yyyy'}}</p>
                        <input placement="top" *ngIf="item.IsEditModeOn" [attr.disabled]="!item.IsEditModeOn ? '' : null" (ngModelChange)="dateOverlapValidation($event,2, i)" type="text" maxlength="10" [(ngModel)]="currentData.LeaseEndDate" required="required" class="form-control" bsDatepicker>
                    </td>
                    <td class="amount">
                        <p *ngIf="!item.IsEditModeOn">${{item.NetOperatingIncome |  number: '1.0-0'}}</p>
                        <div class="textbox-with-btn-left" *ngIf="item.IsEditModeOn">
                            <input *ngIf="item.IsEditModeOn" [attr.disabled]="!item.IsEditModeOn ? '' : null" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"  (ngModelChange)="calcIncreasePercent($event,i)" [(ngModel)]="currentData.NetOperatingIncome" [min]="0" required="required"
                                   dropSpecialCharacters="false" class="form-control " maxlength="18">
                            <span *ngIf="item.IsEditModeOn" _ngcontent-vyd-c7="" class="leftlabel">$</span>
                        </div>
                    </td>
                    <td>
                        <p *ngIf="!item.IsEditModeOn">{{item.Increase |  number: '1.0-2'}}%</p>
                        <div class="textbox-with-btn textbox-with-2character" *ngIf="item.IsEditModeOn">
                            <input *ngIf="item.IsEditModeOn" [attr.disabled]="!item.IsEditModeOn ? '' : null" class="form-control" mask="999.99" [dropSpecialCharacters]="false" [(ngModel)]="currentData.Increase" maxlength="6" (ngModelChange)="validatePercentage($event,i)"
                                   value="{{item.Increase |  number: '0.0-2'}}">
                            <span *ngIf="item.IsEditModeOn" _ngcontent-ysl-c7="" class="rightlabel">%</span>
                        </div>

                    </td>
                    <td *ngIf="IsEditAllowed">
                        <a *ngIf="!item.IsEditModeOn" (click)="openEditRentTermTable(item,i)" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit" (click)="edit"></i></a>
                        <a *ngIf="item.IsEditModeOn" (click)="save(item,i)" tooltip="Save"><i aria-hidden="true" class="fa fa-floppy-o" (click)="save"></i></a>
                        <a *ngIf="!item.IsEditModeOn" class="remove" tooltip="Remove" href="javascript:void(0);" (click)="openModal(template,'deletemodal',i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                        <a *ngIf="item.IsEditModeOn" class="remove" tooltip="Cancel" href="javascript:void(0);" (click)="cancelEdit(item,i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                    </td>
                </tr>
                <tr *ngIf="showRentTermOptions(i)">
                    <td class="table-heading" *ngIf="IsEditAllowed" colspan="6">Options</td>

                    <td class="table-heading" *ngIf="!IsEditAllowed" colspan="6">Options</td>
                </tr>
                <tr *ngIf="item.IsOptional" [ngClass]="{'blue-heighligt': showSaleDate(item)}">
                    <td>
                        <p *ngIf="!item.IsEditModeOn">{{item.Years}}</p>
                        <input *ngIf="item.IsEditModeOn" type="text" class="form-control" [(ngModel)]="currentData.Years" [attr.disabled]="!item.IsEditModeOn ? '' : null" />
                    </td>
                    <td>
                        <p *ngIf="!item.IsEditModeOn">{{item.LeaseStartDate  | date: 'MM/dd/yyyy'}}</p>
                        <input placement="top" *ngIf="item.IsEditModeOn" [attr.disabled]="!item.IsEditModeOn ? '' : null" (ngModelChange)="dateOverlapValidation($event,1, i)" type="text" maxlength="10" [(ngModel)]="currentData.LeaseStartDate" required="required" class="form-control" bsDatepicker>
                    </td>
                    <td>
                        <p *ngIf="!item.IsEditModeOn">{{item.LeaseEndDate | date: 'MM/dd/yyyy'}}</p>
                        <input placement="top" *ngIf="item.IsEditModeOn" [attr.disabled]="!item.IsEditModeOn ? '' : null" (ngModelChange)="dateOverlapValidation($event,2, i)" type="text" maxlength="10" [(ngModel)]="currentData.LeaseEndDate" required="required" class="form-control" bsDatepicker>
                    </td>
                    <td class="amount">
                        <p *ngIf="!item.IsEditModeOn">${{item.NetOperatingIncome |  number: '1.0-0'}}</p>
                        <div class="textbox-with-btn-left" *ngIf="item.IsEditModeOn">

                            <input placement="top" *ngIf="item.IsEditModeOn" [attr.disabled]="!item.IsEditModeOn ? '' : null" currencyMask  [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }"  (ngModelChange)="calcIncreasePercent($event,i)" [(ngModel)]="currentData.NetOperatingIncome" [min]="0" required="required"
                                   dropSpecialCharacters="false" class="form-control " maxlength="18">
                            <span *ngIf="item.IsEditModeOn" _ngcontent-vyd-c7="" class="leftlabel">$</span>
                        </div>
                    </td>
                    <td>
                        <p *ngIf="!item.IsEditModeOn">{{item.Increase |  number: '1.0-2'}}%</p>
                        <div class="textbox-with-btn textbox-with-2character" *ngIf="item.IsEditModeOn">
                            <input *ngIf="item.IsEditModeOn" [attr.disabled]="!item.IsEditModeOn ? '' : null" mask="999.99" class="form-control" [dropSpecialCharacters]="false" [(ngModel)]="currentData.Increase" maxlength="6" (ngModelChange)="validatePercentage($event,i)"
                                   value="{{item.Increase |  number: '0.0-2'}}">
                            <span *ngIf="item.IsEditModeOn" _ngcontent-ysl-c7="" class="rightlabel">%</span>
                        </div>
                    </td>
                    <td *ngIf="IsEditAllowed">
                        <a *ngIf="!item.IsEditModeOn" (click)="openEditRentTermTable(item,i)" tooltip="Edit"><i aria-hidden="true" class="icofont icofont-ui-edit" (click)="edit"></i></a>
                        <a *ngIf="!item.IsEditModeOn" class="remove" tooltip="Remove" href="javascript:void(0);" (click)="openModal(template,'deletemodal',i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                        <a *ngIf="item.IsEditModeOn" (click)="save(item,i)"  tooltip="Save"><i aria-hidden="true" class="fa fa-floppy-o" (click)="save"></i></a>
                        <a *ngIf="item.IsEditModeOn" class="remove" tooltip="Cancel" href="javascript:void(0);" (click)="cancelEdit(item,i)"><i class="icofont icofont-close" aria-hidden="true"></i></a>
                    </td>
                </tr>
            </ng-container>
        </tbody>
        <tbody *ngIf="PropertyHistoryRentTerms?.length == 0">
            <tr>
                <td colspan="5">
                    <div class="nodata">
                        <i class="icofont icofont-warning icon"></i>
                        <p style="color:#878787">No Data Available</p>
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
<!--<input type="hidden" (click)="addRentTerm(templateEditRentTermTable,'panlestyle')" id="hdnAddHistoryRentTermTable" />-->
<ng-template #templateEditRentTermTable>
    <app-edit-rent-term-table [PropertyRentTerm]="PropertyRentTerm" (save)="saveRentTerm($event)" [currentRentTermDetails]="currentRentTermDetails" (close)="closeModal($event)"></app-edit-rent-term-table>
</ng-template>
<ng-template #template>

    <div class="modal-header">
        <h4 class="modal-title pull-left">Delete Rent Term ?</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body padding30">

        <div class="form-group">
            <h6 class="displayvalue">Are you sure to delete ?</h6>
        </div>
        <div class="text-right">
            <button class="btn btn-lg btn-default" (click)="modalRef.hide()">Cancel</button>
            <button class="btn btn-lg btn-danger" (click)="deleteRentTerm();modalRef.hide();">Delete</button>
        </div>
    </div>
</ng-template>



<style>
    .grayBaground > td {
        background-color: #EDF2F5;
    }

    .dark > td {
        font-weight: 900;
    }
</style>
